import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseHubService} from './base-hub.service';
import {IEvenementSpontane} from '../../_models/EvenementSpontane';
import {MessageService} from '../local/message.service';
import {ConfigService} from '../local/config.service';
import {Store} from '@ngrx/store';
import {MainStoreState} from '../../_store/mainStoreState';
import {
  setEvenementsSpontanesAction,
} from '../../_store/EvenementSpontaneStore/evenement-spontane.store';
import {IBaseObject} from '../../_models/BaseObject';

@Injectable({
  providedIn: 'root',
})
export class EsService extends BaseHubService<IEvenementSpontane> {
  constructor(
    private store: Store<MainStoreState>,
    http: HttpClient,
    messageService: MessageService,
    configService: ConfigService
  ) {
    super(
      'evenements-spontanes',
      'hubs/esHub',
      'Evènements spontanés',
      http,
      messageService,
      configService
    );
  }

  refreshHubConnection(): Promise<void> {
    return this.start();
  }

  protected dispatchUpdateData(data: IBaseObject[]): void {
    this.store.dispatch(
      setEvenementsSpontanesAction({payload: data as IEvenementSpontane[]})
    );
  }
}
